import { Typography } from '../Typography/Typography';
import './DevBanner.scss';

interface DevBannerProps {
  title?: string;
  description?: string;
  size?: 'sm' | 'xl';
  className?: string;
}

// Used to indicate features that are still in development. Can be used in different sizes and with custom titles and descriptions.

export const DevBanner = ({ title, description, size = 'sm', className }: DevBannerProps) => {
  const defaultTitle = size === 'sm' ? 'Under utveckling' : 'Här är funktionalitet fortfarande under utveckling';

  return (
    <div className={`dev-banner dev-banner--${size} ${className || ''}`}>
      <i className={`fa-regular fa-triangle-exclamation ${size !== 'sm' ? 'fa-lg' : ''} dev-banner__icon`} />
      <div>
        {size === 'sm' ? (
          <Typography variant="body-3" fontWeight="bold">
            {title || defaultTitle}
          </Typography>
        ) : (
          <Typography variant="body-7" fontWeight="semibold">
            {title || defaultTitle}
          </Typography>
        )}

        {description && <Typography variant={size === 'sm' ? 'body-3' : 'body-5'}>{description}</Typography>}
      </div>
    </div>
  );
};
